module.exports = __webpack_public_path__ + "img/search-mail.8f4fc1ef.png";